<div class="editor">
  <input #input type="text" (blur)="onBlur($event)" [(ngModel)]="params.value" [maxlength]="params?.column?.colDef?.maxlength">
</div>
